import { isAllowed } from '../../Apollo/allower';
import permissions from '../../Apollo/permissions';

export function isAllowedToInsertConsentCategory() {
  return isAllowed(permissions.createConsentCategory);
}
